import { render, staticRenderFns } from "./ConfigurationsView.vue?vue&type=template&id=b9e9172a&scoped=true"
import script from "./ConfigurationsView.vue?vue&type=script&lang=js"
export * from "./ConfigurationsView.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationsView.vue?vue&type=style&index=0&id=b9e9172a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e9172a",
  null
  
)

export default component.exports